module.exports = __webpack_public_path__ + "static/img/no-winner.43e428e2.png";